import { HTMLAttributes } from 'react';
import classNames from 'classnames';

import './Share.scss';

import Typography from '../typography/Typography';
import { ShareIcon, ThumbsUpIcon } from '../common.icons';

export type TLike = {
  count?: number;
  onLike?: () => void;
  onUnLike?: () => void;
  active?: boolean;
} & HTMLAttributes<HTMLDivElement>;

const Share = ({ count = 0, className, onClick, active = false, ...rest }: TLike) => {
  return (
    <div
      className={classNames('like-component', className, { 'like-component--is-active': active })}
      {...rest}
      onClick={onClick}
    >
      <Typography as="span" variant="body-2" fontWeight="medium">
        <ShareIcon /> <span>
          {/* {count}  */}
          Share</span>
      </Typography>
    </div>
  );
};

export default Share;
